module.exports = __webpack_public_path__ + "img/229-turkmenistan.42a11ebc.svg";